/* istanbul ignore file */
import { takeLatest, fork } from 'redux-saga/effects'

import browserHistory from 'commons/js/browserHistory'
import {
    NAVIGATE_TO,
    RELOAD,
    PUSH,
} from '../actions/types'

function * navigateTo ({ url, target = null }) {
    // Side effects should be performed inside sagas. Here we're navigating
    // outside application.
    target
        ? window.open(url, target)
        : window.location.assign(url)
}

function * reload (forceReload = false) {
    document.location.reload(forceReload)
}

function * push ({ url }) {
    browserHistory.push({ pathname: url })
}
function * watchNavigateTo () {
    yield takeLatest(NAVIGATE_TO, navigateTo)
}

function * watchReload () {
    yield takeLatest(RELOAD, reload)
}

function * watchPush () {
    yield takeLatest(PUSH, push)
}
export default function * () {
    yield [
        fork(watchNavigateTo),
        fork(watchReload),
        fork(watchPush),
    ]
}
